import { ChangeEvent, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { useFormik } from "formik";
import Select from "react-select";
import { DOMAIN_STATUS } from "helpers/constans";
import MediaApi from "api/mediaApi";
interface Props {
  open: boolean;
  data: any;
  onClose: () => void;
  onSubmit: (value: any) => void;
}

const ModalChange = ({ open, data, onClose, onSubmit }: Props) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      api_key: "",
      host: "",
      port: "",
      username: "",
      password: "",
      path: "",
    },
    onSubmit: (values: any) => {
      onSubmit(values);
    },
  });

  useEffect(() => {
    if (open) {
      formik.setValues({
        api_key: data?.api_key,
        host: data?.host,
        port: data?.port === 0 ? "" : data?.port,
        username: data?.username,
        password: data?.password,
        path: data?.path,
      });
    } else {
      formik.resetForm();
    }
  }, [open, data]);

  return (
    <Modal isOpen={open} centered={true} scrollable={false}>
      <ModalHeader>{t("media.api_input")}</ModalHeader>
      <ModalBody className="">
        <div>
          <div className="mb-1">{t("media.enter_and_save_portal_api_key")}</div>
          <div className="d-flex align-items-center gap-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.api_key_value")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.api_key_placeholder")}
              {...formik.getFieldProps("api_key")}
              maxLength={255}
            />
          </div>
          <h5 className="mt-3">{t("media.enter_FTP")}</h5>
          <div className="mb-1">
            {t("media.placeholder_enter_the_FTP_information")}
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.host")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.placeholder_enter_the_information")}
              {...formik.getFieldProps("host")}
              maxLength={255}
            />
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.port")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.placeholder_enter_the_information")}
              {...formik.getFieldProps("port")}
              maxLength={10}
            />
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.username")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.placeholder_enter_the_information")}
              {...formik.getFieldProps("username")}
              maxLength={255}
            />
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.password")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.placeholder_enter_the_information")}
              {...formik.getFieldProps("password")}
              maxLength={255}
            />
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <div style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              {t("media.path")}
            </div>
            <Input
              type="text"
              className="form-control"
              placeholder={t("media.placeholder_enter_the_information")}
              {...formik.getFieldProps("path")}
              maxLength={255}
            />
          </div>
          <div className="hstack gap-2 mt-5 justify-content-center">
            <button
              className="btn btn-soft-secondary fs-14 w-25"
              type="button"
              color="light"
              onClick={() => onClose()}
            >
              {t("media.Cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary fs-14 w-25"
              onClick={() => formik.handleSubmit()}
            >
              {t("media.Save")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

const AcceptFileType = [
  "image/jpg",
  "application/pdf",
  "image/png",
  "image/jpeg",
];
const AdditionalFeatures = ({
  mediaDetail,
  setFieldValue,
  portalSettings,
  mode,
  onClose,
  handleSubmit,
  kakaoSetting,
  values,
  errors
}: any) => {
  const { t } = useTranslation();
  const [modalUpdateKey, setModalUpdateKey] = useState({
    visible: false,
    data: {
      index: 0,
      api_key: "",
      host: "",
      port: "",
      username: "",
      password: "",
      path: "",
    },
  });
  const [loading, setLoading] = useState<boolean>(false);
  const optionDomainKakao = [
    {
      label: t("media.not_entered"),
      value: DOMAIN_STATUS.NONE,
    },
    {
      label: t("media.input_completion"),
      value: DOMAIN_STATUS.REGISTERED,
    },
  ];
  const handleUploadFile = async (event: any) => {
    if (
      event?.target?.files === null ||
      event.target?.files?.length === 0 ||
      !AcceptFileType.includes(event?.target?.files?.[0]?.type)
    ) {
      return;
    }
    setLoading(true);
    const res: any = await MediaApi.updateImage({
      company_id: mediaDetail?.id,
      files: [event.target.files[0]],
    });
    setLoading(false)
    if (res?.statusCode == 200) {
      setFieldValue("newspaper_ethics_committee_setting.image_url", res?.data[0]?.path);
    };
    event.target.value = "";
  };
  const selectDomainStatus = useMemo(() => {
    return optionDomainKakao.find(
      (item: any) => item.value === kakaoSetting?.domain_status
    );
  }, [kakaoSetting]);

  const getFileSize = async (fileUrl: string) => {
    const url = new URL(fileUrl);
    url.searchParams.set('_t', Date.now().toString());

    const response = await fetch(url.toString(), { cache: 'no-store' });
    const blob = await response.blob();
    const bytes = blob.size;
    const kilobytes = bytes / 1024;
    const megabytes = kilobytes / 1024;

    if (megabytes >= 1) {
      return megabytes.toFixed(2) + " MB";
    } else {
      return kilobytes.toFixed(2) + " KB";
    }
  };

  const getFileNameFromUrl = (url: string) => {
    try {
      const pathname = new URL(url).pathname;
      return decodeURIComponent(pathname.substring(pathname.lastIndexOf('/') + 1)) || 'untitled';
    } catch {
      return 'untitled';
    }
  }
  const [fileSize, setFileSize] = useState("");

  useEffect(() => {
    if (values?.newspaper_ethics_committee_setting?.image_url) {
      getFileSize(values?.newspaper_ethics_committee_setting?.image_url)
        .then((size) => {
          setFileSize(size);
        })
        .catch((err) => {
        });
    }
  }, [values?.newspaper_ethics_committee_setting?.image_url]);

  return (
    <div>
      <form onSubmit={handleSubmit} className="w-100">
        <div>
          <div className="fw-bold">{t("media.kakao_talk_sharing")}</div>
          <div className="d-flex gap-4">
            <div className="d-flex align-items-center gap-4 form-check form-switch form-switch-right form-switch-md">
              {t("media.enable_feature_display")}
              <Input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={kakaoSetting?.is_active}
                onChange={(event) =>
                  setFieldValue("kakao_setting.is_active", event.target.checked)
                }
              />
            </div>
            <div className="d-flex align-items-center gap-4 ">
              <div>{t("media.kakao_domain_registered")}</div>
              <div style={{ width: "150px" }}>
                <Select
                  className="mb-0"
                  options={optionDomainKakao}
                  value={selectDomainStatus}
                  onChange={(event: any) => {
                    setFieldValue("kakao_setting.domain_status", event?.value);
                  }}
                ></Select>
              </div>
            </div>
          </div>
        </div>
        <div className="fs-14 mt-4">
          <div className="fw-bold">{t("media.kakao_javascript_key")}</div>
          <div className="d-flex gap-4">
            <Input
              className="form-check-input mt-2"
              type="text"
              placeholder={t("media.placeholder_javascript_key")}
              style={{
                borderRadius: "var(--vz-border-radius)",
                zIndex: 2,
                background: "transparent",
                padding: "2px 10px",
                height: "36px",
                width: "286px",
              }}
              maxLength={200}
              onChange={(event) => setFieldValue("kakao_setting.share_key", event.target.value)}
              value={values?.kakao_setting?.share_key || ""}
            />
          </div>
        </div>
        <div className="mt-4">
          <div className="fw-bold">{t("media.activate_news_portal")}</div>
          <div>{t("media.only_checked_news_portals_visible")}</div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            columnGap: "40px",
            rowGap: "10px",
          }}
          className="mt-4 align-items-center"
        >
          {portalSettings?.map((item: any, index: number) => (
            <div
              className="d-flex gap-4 align-items-center w-100"
              key={item?.id}
            >
              <div className="d-flex justify-content-between align-items-center gap-4 w-100">
                <div className="d-flex align-items-center gap-2">
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      borderRadius: "999px",
                      backgroundColor: item?.color,
                      border: `1px solid ${item?.color}`,
                    }}
                  ></div>
                  <div>{item?.name}</div>
                </div>
                <div
                  onClick={() => {
                    setModalUpdateKey({
                      visible: true,
                      data: {
                        index,
                        api_key: item?.api_key,
                        host: item?.host,
                        port: item?.port,
                        username: item?.username,
                        password: item?.password,
                        path: item?.path,
                      },
                    });
                  }}
                  style={{
                    border: "1px solid #D3D5DB",
                    borderRadius: "12px",
                    width: "64px",
                    height: "26px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  {t("media.api_input")}
                </div>
              </div>
              <Input
                className="form-check-input"
                type="checkbox"
                role="switch"
                name="is_active"
                checked={item?.is_active}
                onChange={(e) => {
                  setFieldValue(
                    `portal_settings.${index}.is_active`,
                    e?.target?.checked
                  );
                }}
              />
            </div>
          ))}
        </div>
        <div>
          <div className="fs-14 fw-bold mt-4">
            인터넷신문윤리위원회 로고설정 [하단푸터]
            <div className="d-flex gap-2 align-items-center fw-normal  mt-2">
              <div className="fs-13">로고 노출 활성화</div>
              <div className="form-check form-switch">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="is_active"
                  onChange={(event) =>
                    setFieldValue("newspaper_ethics_committee_setting.is_active", event.target.checked)
                  }
                  checked={values?.newspaper_ethics_committee_setting?.is_active}
                />
              </div>
            </div>
            <div className="d-flex gap-3 mt-2">
              <div>
                1.이미지 등록
                <label
                  htmlFor="file-upload"
                  className="mt-2 d-flex flex-column align-items-center justify-content-center border border-1 rounded "
                  style={{
                    width: "106px",
                    height: "36px",
                    cursor: "pointer",
                  }}
                >
                  {loading ? <Spinner size="sm" className='me-2' /> : "첨부하기"}
                </label>
                <input
                  id="file-upload"
                  type="file"
                  className="d-none"
                  accept={AcceptFileType.toString()}
                  onChange={handleUploadFile}
                />
              </div>
              <div>
                2.URL 설정
                <Input
                  type="text"
                  placeholder=""
                  className="mt-2"
                  style={{
                    borderRadius: "var(--vz-border-radius)",
                    zIndex: 2,
                    background: "transparent",
                    padding: "2px 10px",
                    height: "36px",
                    width: "286px",
                  }}
                  onChange={(event) =>
                    setFieldValue("newspaper_ethics_committee_setting.url", event.target.value)
                  }
                  value={values?.newspaper_ethics_committee_setting?.url}
                  invalid={!!errors?.newspaper_ethics_committee_setting?.url}
                />
              </div>
            </div>
            {
              values?.newspaper_ethics_committee_setting?.image_url ? (
                <div>
                  {getFileNameFromUrl(values?.newspaper_ethics_committee_setting?.image_url)} {fileSize}
                </div>
              ) : <></>
            }
          </div>
          <div className="fs-14 fw-bold mt-4">
            인터넷신문윤리위원회 문구설정 [하단푸터]
            <div className="d-flex gap-2 align-items-center fw-normal  mt-2">
              <div className="fs-13">문구 노출 활성화</div>
              <div className="form-check form-switch">
                <Input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="chatNotification"
                  checked={values?.newspaper_ethics_committee_setting?.bottom_footer?.is_active}
                  onChange={(event) =>
                    setFieldValue(
                      "newspaper_ethics_committee_setting.bottom_footer.is_active",
                      event.target.checked
                    )
                  }
                />
              </div>
            </div>
            <div className="d-flex gap-3 mt-2">
              <div>
                대표번호
                <Input
                  type="text"
                  value={values?.newspaper_ethics_committee_setting?.bottom_footer?.phone_number}
                  onChange={(event) =>
                    setFieldValue(
                      "newspaper_ethics_committee_setting.bottom_footer.phone_number",
                      event.target.value
                    )
                  }
                  placeholder=""
                  className="mt-2"
                  style={{
                    borderRadius: "var(--vz-border-radius)",
                    zIndex: 2,
                    background: "transparent",
                    padding: "2px 10px",
                    height: "36px",
                    width: "204px",
                  }}
                />
              </div>
              <div>
                이메일
                <Input
                  value={values?.newspaper_ethics_committee_setting?.bottom_footer?.email}
                  type="email"
                  onChange={(event) =>
                    setFieldValue("newspaper_ethics_committee_setting.bottom_footer.email", event.target.value)
                  }
                  placeholder=""
                  className="mt-2"
                  style={{
                    borderRadius: "var(--vz-border-radius)",
                    zIndex: 2,
                    background: "transparent",
                    padding: "2px 10px",
                    height: "36px",
                    width: "204px",
                  }}
                />
              </div>
              <div>
                고충처리인 이름
                <Input
                  value={values?.newspaper_ethics_committee_setting?.bottom_footer?.name}
                  type="text"
                  onChange={(event) =>
                    setFieldValue("newspaper_ethics_committee_setting.bottom_footer.name", event.target.value)
                  }
                  placeholder=""
                  className="mt-2"
                  style={{
                    borderRadius: "var(--vz-border-radius)",
                    zIndex: 2,
                    background: "transparent",
                    padding: "2px 10px",
                    height: "36px",
                    width: "204px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="hstack gap-2 mt-5 justify-content-center">
          {mode === "view" ? (
            <button
              type="button"
              onClick={() => {
                onClose();
              }}
              className="btn btn-primary mx-auto fs-14 w-25"
            >
              {t("media.Check")}
            </button>
          ) : (
            <>
              <button
                className="btn btn-soft-secondary fs-14 w-25"
                type="button"
                color="light"
                onClick={() => onClose()}
              >
                {t("media.Cancel")}
              </button>
              <button type="submit" className="btn btn-primary fs-14 w-25">
                {t("media.Save")}
              </button>
            </>
          )}
        </div>
      </form>
      <ModalChange
        open={modalUpdateKey?.visible}
        data={modalUpdateKey?.data}
        onClose={() =>
          setModalUpdateKey({
            visible: false,
            data: {
              index: 0,
              api_key: "",
              host: "",
              port: "",
              username: "",
              password: "",
              path: "",
            },
          })
        }
        onSubmit={(e) => {
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.api_key`,
            e?.api_key
          );
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.host`,
            e?.host
          );
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.port`,
            e?.port
          );
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.username`,
            e?.username
          );
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.password`,
            e?.password
          );
          setFieldValue(
            `portal_settings.${modalUpdateKey?.data?.index}.path`,
            e?.path
          );
          setModalUpdateKey({
            visible: false,
            data: {
              index: 0,
              api_key: e?.api_key,
              host: e?.host,
              port: e?.port,
              username: e?.username,
              password: e?.password,
              path: e?.path,
            },
          });
        }}
      />
    </div>
  );
};

export default AdditionalFeatures;
